import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import {BrowserRouter, Route, Routes} from "react-router-dom";
import Overview from "./Overview";
import Rules from "./Rules";
import GroupMeIndex from "./GroupMeIndex";

document.title = 'Nav Snipes';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <BrowserRouter basename={process.env.PUBLIC_URL}>
            <Routes path="/">
                <Route index element={<Overview />} />
                <Route path="rules" element={<Rules />} />
                <Route path="gmindex" element={<GroupMeIndex />} />
                <Route path='*' element={<>404</>} />
            </Routes>
        </BrowserRouter>
    </React.StrictMode>
);